import type { ReactNode } from 'react'
import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import BannerBody from '@vfuk/core-banner-body'
import Image from '@vfuk/core-image'
import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/FiftyFiftyBanner.style'

import type { FiftyFiftyBannerProps } from './FiftyFiftyBanner.types'
import localTheme from './themes/FiftyFiftyBanner.theme'
import type { Appearance } from './themes/FiftyFiftyBanner.theme.types'

export class FiftyFiftyBanner extends PureComponent<FiftyFiftyBannerProps> {
  public componentName = 'FiftyFiftyBanner'

  public static defaultProps: Partial<FiftyFiftyBannerProps> = {
    bodyPosition: 'left',
    appearance: 'primary',
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  private getFootnoteProp = (appearance: Appearance): FiftyFiftyBannerProps['footnote'] | {} => {
    return this.props.footnote
      ? {
          footnote: {
            ...this.props.footnote!,
            icon: {
              name: this.props.footnote!.icon!.name,
              appearance: appearance.iconAppearance,
              inverse: appearance.inverseIcon,
            },
          },
        }
      : {}
  }

  public render(): ReactNode {
    const appearance = localTheme(this.props.theme!).appearance[this.props.appearance!]
    const footnoteProp = this.getFootnoteProp(appearance)

    return (
      <Styled.FiftyFiftyBanner
        appearance={this.props.appearance!}
        bodyPosition={this.props.bodyPosition}
        id={this.props.id}
        data-selector={getDataSelector(this.props.dataSelectorPrefix)}
        data-component-name={this.componentName}
        {...this.props.dataAttributes}
      >
        <Styled.BannerContent bodyPosition={this.props.bodyPosition}>
          <Styled.ContentWrapper>
            <BannerBody
              justify='left'
              inverse={appearance.inverseText}
              heading={{
                level: this.props.heading.level || 2,
                text: this.props.heading.text,
                weight: 1,
              }}
              text={this.props.text}
              primaryButton={{
                ...this.props.primaryButton!,
                appearance: appearance.primaryButtonAppearance,
                inverse: appearance.inverseButton,
              }}
              secondaryButton={{
                ...this.props.secondaryButton!,
                appearance: appearance.secondaryButtonAppearance,
                inverse: appearance.inverseButton,
              }}
              {...footnoteProp}
              dataSelectorPrefix={getDataSelector(this.props.dataSelectorPrefix, 'banner-body')}
            />
          </Styled.ContentWrapper>
        </Styled.BannerContent>
        <Styled.BannerImage
          backgroundImage={this.props.backgroundImage}
          verticalAlign={this.props.primaryImage && this.props.primaryImage.verticalAlign}
          data-selector={getDataSelector(this.props.dataSelectorPrefix, 'background-image')}
        >
          {this.props.primaryImage && (
            <Image
              {...this.props.primaryImage}
              alt={this.props.primaryImage!.alt}
              dataSelectorPrefix={getDataSelector(this.props.dataSelectorPrefix, 'primary-image')}
            />
          )}
          {this.props.secondaryImage && (
            <Styled.SecondaryImageWrapper bodyPosition={this.props.bodyPosition}>
              <Image
                sm={{
                  src: this.props.secondaryImage!.src,
                }}
                alt={this.props.secondaryImage!.alt}
                dataSelectorPrefix={getDataSelector(this.props.dataSelectorPrefix, 'secondary-image')}
              />
            </Styled.SecondaryImageWrapper>
          )}
        </Styled.BannerImage>
      </Styled.FiftyFiftyBanner>
    )
  }
}

export default withTheme(FiftyFiftyBanner)
